import { useState } from 'react';
import { FormRow } from '@gravity-ui/components';

import { Button, Icon, Select, Sheet } from '@gravity-ui/uikit';
import { Xmark } from '@gravity-ui/icons';
import styles from '../styles.module.scss';

export const YearSelect = ({
	isMobile,
	formText,
	yearsOptions,
	register,
	formValues,
	setValue,
	isSubmitted,
	errors,
}: any) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			{isMobile ? (
				<FormRow className={styles.info__row} label={formText.yearBlank} required>
					<Select
						open={isOpen}
						onOpenChange={setIsOpen}
						filterable
						width={300}
						className={styles.info__row__select}
						size="xl"
						placeholder={formText.year}
						options={yearsOptions}
						{...register('birthday', { required: true })}
						value={
							formValues.birthday ? [new Date(formValues.birthday).getFullYear().toString()] : undefined
						}
						onUpdate={(value) => {
							const formattedDate = value ? `${new Date(value[0]).getFullYear()}-01-01` : '';
							setValue('birthday', formattedDate);
						}}
						validationState={isSubmitted && errors.birthday ? 'invalid' : undefined}
						errorPlacement="inside"
						errorMessage={errors.birthday ? errors.birthday.message : ''}
						renderPopup={({ renderFilter, renderList }) => (
							<Sheet
								visible={isOpen}
								onClose={() => setIsOpen(false)}
								title="Год рождения"
								className={styles.sheet}
							>
								<div className={styles.sheet__close}>
									<Button onClick={() => setIsOpen(false)} view="flat">
										<Icon data={Xmark} size={16} />
									</Button>
								</div>
								<div className={styles.sheet__content}>
									{renderFilter?.()}
									{renderList?.()}
								</div>
							</Sheet>
						)}
					/>
				</FormRow>
			) : (
				<FormRow className={styles.info__row} label={formText.yearBlank} required>
					<Select
						filterable
						width={300}
						className={styles.info__row__select}
						size="xl"
						placeholder={formText.year}
						options={yearsOptions}
						{...register('birthday', { required: true })}
						value={
							formValues.birthday ? [new Date(formValues.birthday).getFullYear().toString()] : undefined
						}
						onUpdate={(value) => {
							const formattedDate = value ? `${new Date(value[0]).getFullYear()}-01-01` : '';
							setValue('birthday', formattedDate);
						}}
						validationState={isSubmitted && errors.birthday ? 'invalid' : undefined}
						errorPlacement="inside"
						errorMessage={errors.birthday ? errors.birthday.message : ''}
					/>
				</FormRow>
			)}
		</>
	);
};
